// Modul Z6 (reczne zamowienia PrestaShop) - widocznosc sterowana build-time.
// REACT_APP_Z6_HOSTS: hostname'y oddzielone przecinkami (np. swt.openkontakt.com).
// Brak zmiennej = funkcja dostepna dla wszystkich (stan docelowy po pilotalu).
const HOSTS_RAW = (process.env.REACT_APP_Z6_HOSTS || '').trim();
const HOSTS: string[] = HOSTS_RAW
  ? HOSTS_RAW.split(',').map((h: string) => h.trim().toLowerCase()).filter((h: string) => h.length > 0)
  : [];

export const z6ManualOrders = (): boolean => {
  if (HOSTS.length === 0) return true;
  const host = (window.location.hostname || '').toLowerCase();
  return HOSTS.indexOf(host) >= 0;
};
